/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Rebuy ATC - add product delivery property
 */
// Rebuy product add-on
document.addEventListener('rebuy.ready', function (event) {
    updateDeliveryOnRebuyAddon(event)

    // update the delivery property if add-on product variant gets changed
    var variantSelectElements = event.detail.widget.template[0].querySelectorAll('.rebuy-product-options .rebuy-select')
    variantSelectElements.forEach((select) => {
        select.addEventListener('change', function () {
            updateDeliveryOnRebuyAddon(event)
        })
    })
})
// Rebuy popup upsell
document.addEventListener('rebuy.beforeAdd', function (event) {
    updateDeliveryOnRebuyPopup(event)
})
function updateDeliveryOnRebuyAddon(event) {
    var delivery = window.languages.productDelivery

    event.detail.widget.data.products.forEach((p) => {
        var { variantDeliveryValue, deliveryValue } = identifyProductDeliveryValue(p)
        p.properties[delivery] = variantDeliveryValue || deliveryValue
    })
}
function updateDeliveryOnRebuyPopup(event) {
    var delivery = window.languages.productDelivery
    var p = event.detail.product
    var { variantDeliveryValue, deliveryValue } = identifyProductDeliveryValue(p)
    p.properties[delivery] = variantDeliveryValue || deliveryValue
}
function identifyProductDeliveryValue(p) {
    var deliveryValue = window.languages.productDeliveryValue // Default delivery value
    var variantDeliveryValue = ''
    var deliveryTags = p.tags.split(', ').filter((t) => t.includes('__delivery:'))

    var extraDeliveryTags = p.tags.split(', ').filter((t) => t.includes('__extraDelivery:'))
    if (extraDeliveryTags.length) {
        deliveryTags = extraDeliveryTags
    }

    // Example delivery tag formats:
    // __delivery:2-4 days
    // __delivery:123456:2-4 days (with variant SKU)
    if (deliveryTags.length) {
        for (const tag of deliveryTags) {
            var split = tag.split(':')
            if (split[2] && p.selected_variant.sku == split[1]) {
                // if variant SKU is in the tag and it is current variant
                variantDeliveryValue = split[2]
                break
            } else if (split[2]) {
                // if variant SKU is in the tag but not selected
                // do nothing
            } else {
                deliveryValue = split[1]
            }
        }
    }
    return { variantDeliveryValue, deliveryValue }
}

/**
 * Product FAQ accordion script
 */

document.addEventListener('DOMContentLoaded', function () {
    // var faqSection = document.getElementById('faq-section')
    var questions = document.querySelectorAll('.faq-section p strong')

    questions.forEach(function (question) {
        question.parentElement.addEventListener('click', function () {
            var current = this.nextElementSibling

            while (current && !current.querySelector('strong')) {
                if (current.style.display === 'block') {
                    current.style.display = 'none'
                    question.classList.remove('open')
                } else {
                    current.style.display = 'block'
                    question.classList.add('open')
                }
                current = current.nextElementSibling
            }
        })
    })
})
